import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';
import { CustomersTypes } from 'features/account';

import usestorage from 'app/utils/storage';

import { ActiveCampaingIdsState, BuyCaptcha, BuyInformationResponse, CheckoutState, PaymentsResponse, PaymentsState } from '../types';

const storage = usestorage('sessionStorage');

const initialState: PaymentsState = {
  buyInformation: undefined!,
  paymentsResponse: undefined!,
  activeCampaingIds: undefined!,
  checkout: {
    paymentStep: 'loading',
    leadUuid: '',
    customerUuid: '',
    sendLead: true,
    isStudent: false,
    bypassLogin: false,
    customerType: CustomersTypes.Person,
    customerName: '',
    customerContactEmail: '',
    customerContactEmailConfirm: '',
    customerBirthOrFoundation: '',
    customerTaxId: '',
    customerContactPhone: '',
    internationalContactPhone: false,
    customerAddressLine1: '',
    customerAddressNumber: '',
    customerAddressLine2: '',
    customerNeighborhood: '',
    customerZipCode: '',
    customerCity: '',
    customerState: '',
    customerCountry: 'BR',
    value: 0,
    spotValue: 0,
    paymentMethod: 'creditCard',
    installments: 0,
    creditCardHolderName: '',
    creditCardExpirationMonth: 0,
    creditCardExpirationYear: 0,
    creditCardNumber: '',
    creditCardSecurityCode: '',
    withBirthDate: true,
    withAddress: true,
    withEMailConfirmation: true,
    withPhone: true,
    withTaxId: true,
    disableCaptcha: false,
  },
  showLogin: false,
  showLoginMessage: false,
  bypassLogin: false,
  hasAccount: false,
  captcha: undefined!,
};

const paymentsSlice = createSlice({
  name: 'offers',
  initialState,
  reducers: {
    setBuyInformationAction(state, action: PayloadAction<BuyInformationResponse>) {
      state.buyInformation = action.payload;
    },

    setCheckoutAction(state, action: PayloadAction<Partial<CheckoutState>>) {
      state.checkout = { ...state.checkout, ...action.payload };
    },

    clearCheckoutAction(state) {
      state.checkout = initialState.checkout;
    },

    setPaymentsResponseAction(state, action: PayloadAction<PaymentsResponse>) {
      state.paymentsResponse = action.payload;
    },

    setActiveCampaingIdsAction(state, action: PayloadAction<Partial<ActiveCampaingIdsState>>) {
      state.activeCampaingIds = action.payload;
    },

    setLoginAction(
      state,
      action: PayloadAction<
        Partial<{
          showLogin: boolean;
          showLoginMessage: boolean;
          bypassLogin: boolean;
          hasAccount: boolean;
        }>
      >
    ) {
      if (typeof action.payload.showLogin !== 'undefined') state.showLogin = action.payload.showLogin;

      if (typeof action.payload.showLoginMessage !== 'undefined') state.showLoginMessage = action.payload.showLoginMessage;

      if (typeof action.payload.bypassLogin !== 'undefined') state.bypassLogin = action.payload.bypassLogin;

      if (typeof action.payload.hasAccount !== 'undefined') state.hasAccount = action.payload.hasAccount;

      if (state.showLogin) {
        storage.set('redirect_url', `/${window.location.pathname.substring(1)}${window.location.search}`);
      } else {
        storage.remove('redirect_url');
      }
    },

    setCaptchaAction(state, action: PayloadAction<BuyCaptcha>) {
      state.captcha = action.payload;
    },
  },
});

export const {
  setBuyInformationAction,
  setCheckoutAction,
  clearCheckoutAction,
  setLoginAction,
  setPaymentsResponseAction,
  setActiveCampaingIdsAction,
  setCaptchaAction,
} = paymentsSlice.actions;

export const getOffers = (state: RootState): PaymentsState => state.offers;

export default paymentsSlice.reducer;
